import { render, staticRenderFns } from "./premesisEquipment.vue?vue&type=template&id=0e56f8a5&"
import script from "./premesisEquipment.vue?vue&type=script&lang=js&"
export * from "./premesisEquipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports